import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import StudentCard from "../student/common/studentCardv2";
import StudentDetailsDialog from "../student/common/studentDetailsDialog_v2";
import {
	getStudentDetails,
	resetStudentToShowDetails,
} from "../../../actions/thirdYearStudentActions";
import { selectStudentsAfterInterview } from "../../../actions/companyActions";
import { InterviewBatchStatus } from "../../../utils/constants";
import { withRouter } from "react-router-dom";
import FinalNotification from "./FinalNotification";
import { Row, Col, Empty, Divider, Checkbox, Modal } from "antd";
import GalkButton from "../../common/component/button";
import { RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ReturnBackIcon } from "../../common/icons";
import "./style.css";

const InterviewPanel = ({
	studentList,
	getStudentDetails,
	resetStudentToShowDetails,
	selectStudentsAfterInterview,
	ifActionInProgress,
	studentDetails,
	isLoading,
	currentInterviewBatch,
	studentsSelectedForInterview,
	studentsfinallySelectedForInternship,
}) => {
	const [showStudentDetails, setShowStudentDetails] = useState(false);
	const [currentStep, setCurrentStep] = useState(0);
	const [studentsInInterviewPanel, setStudentsInInterviewPanel] = useState([]);
	const [studentsFinallySelected, setStudentsFinallySelected] = useState([]);
	const [studentSelectionEnabled, setStudentSelectionEnabled] = useState(false);
	const [openFinalSelectionConfirmModal, setOpenFinalSelectionConfirmModal] =
		useState(false);
	const [readyToStartInterview, setReadyToStartInterview] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (currentInterviewBatch && currentInterviewBatch.current) {
			setStudentSelectionEnabled(false);

			if (
				currentInterviewBatch.status ===
				InterviewBatchStatus.InterviewSlotBooked
			) {
				setCurrentStep(0);
				const selectedStudentList = currentInterviewBatch.studentsList;
				if (studentList && studentList.length > 0) {
					const selectedStudentProfile = studentList.filter(
						(x) => selectedStudentList.findIndex((id) => x.id === id) >= 0
					);

					setStudentsInInterviewPanel(selectedStudentProfile);
				}
			}
			if (
				currentInterviewBatch.status === InterviewBatchStatus.InterviewComplete
			) {
				setCurrentStep(1);
				const selectedStudentList = currentInterviewBatch.selectedStudentList;
				if (studentList && studentList.length > 0) {
					const selectedStudentProfile = studentList.filter(
						(x) => selectedStudentList.findIndex((id) => x.id === id) >= 0
					);

					setStudentsFinallySelected(selectedStudentProfile);
				}
			}
		}
		if (
			studentsSelectedForInterview &&
			studentsSelectedForInterview.length > 0
		) {
			let allApproved = true;
			studentsSelectedForInterview.forEach((x) => {
				if (!x.interviewTimeApproved) allApproved = false;
			});

			if (allApproved) {
				setReadyToStartInterview(true);
				setCurrentStep(0);
				const selectedStudentList = studentsSelectedForInterview.map(
					(x) => x.studentId
				);
				if (studentList && studentList.length > 0) {
					const selectedStudentProfile = studentList.filter(
						(x) => selectedStudentList.findIndex((id) => x.id === id) >= 0
					);

					setStudentsInInterviewPanel(selectedStudentProfile);
				}
			}
		}
		if (
			studentsfinallySelectedForInternship &&
			studentsfinallySelectedForInternship.length > 0
		) {
			setCurrentStep(1);
			const selectedStudentList = studentsfinallySelectedForInternship.map(
				(x) => x.studentId
			);
			if (studentList && studentList.length > 0) {
				const selectedStudentProfile = studentList.filter(
					(x) => selectedStudentList.findIndex((id) => x.id === id) >= 0
				);

				setStudentsFinallySelected(selectedStudentProfile);
			}
		}
	}, [
		currentInterviewBatch,
		studentList,
		studentsSelectedForInterview,
		studentsfinallySelectedForInternship,
	]);

	const showStudentDetailsHandler = (studentId) => {
		setShowStudentDetails(true);
		getStudentDetails(studentId);
	};

	const closeStudentDetailsHandler = () => {
		setShowStudentDetails(false);
		resetStudentToShowDetails();
	};

	const onStudentSelect = (e, studentId) => {
		let _selectedStudents = [...new Set(studentsFinallySelected)];
		const checked = e.target.checked;

		if (checked) {
			_selectedStudents.push(studentList.find((stu) => stu.id === studentId));
		} else {
			_selectedStudents = _selectedStudents.filter(
				(stu) => stu.id !== studentId
			);
		}

		setStudentsFinallySelected(_selectedStudents);
	};

	const onDetermineStudentStepButtonClick = () => {
		setStudentSelectionEnabled(true);
	};

	const onStudentFinalSelect = () => {
		setOpenFinalSelectionConfirmModal(true);
	};

	const confirmFinalSelection = () => {
		setCurrentStep(1);

		let interviewBatch = {
			...currentInterviewBatch,
			selectedStudentList: studentsFinallySelected.map((x) => x.id),
			updatedDate: moment().format("LL"),
			status: InterviewBatchStatus.InterviewComplete,
		};
		selectStudentsAfterInterview(interviewBatch);
		setOpenFinalSelectionConfirmModal(false);
	};

	const onSelectStudentStepCancelButtonClick = () => {
		setCurrentStep(0);
		setStudentSelectionEnabled(false);
		setStudentsFinallySelected([]);
	};

	return (
		<div className="internship_selectStudents_pageContainer">
			<div className="pageHeader_row">
				<div className="selectStudent_container_card_title_container">
					<div className="selectStudent_container_card_title_primary">
						{t("internship_determineStudent_pageTitle")}
					</div>
					<div className="selectStudent_container_card_title-_econdary">
						{currentStep < 1 ? (
							<>
								{readyToStartInterview ? (
									<span>
										{t("internship_determineStudent_pageTitle_secondary")}
									</span>
								) : (
									<span>
										{t(
											"internship_determineStudent_pageTitle_secondary_notReady"
										)}
									</span>
								)}
							</>
						) : (
							<>
								{currentInterviewBatch &&
									currentInterviewBatch.status ===
										InterviewBatchStatus.InterviewComplete && (
										<span>
											{t(
												"internship_determineStudent_finalStep_pageTitle_secondary"
											)}
										</span>
									)}
							</>
						)}
					</div>
				</div>
			</div>
			{currentStep === 1 && (
				<div className="taggedStudents_stepNotificationContainer">
					<FinalNotification />
				</div>
			)}
			{currentInterviewBatch &&
				currentInterviewBatch.status ===
					InterviewBatchStatus.InterviewSlotBooked && (
					<div className="taggedStudents_stepActionContainer">
						{currentStep === 0 && !studentSelectionEnabled && (
							<div className="justifyContent_end">
								<GalkButton
									type="primary"
									width={180}
									onClick={onDetermineStudentStepButtonClick}
								>
									{t(
										"internship_determineStudent_actionButton_determineStudents"
									)}
									<RightOutlined />
								</GalkButton>
							</div>
						)}
						{currentStep === 0 && studentSelectionEnabled && (
							<div className="justifyContent_spaceBetween">
								<GalkButton
									width={90}
									type="default"
									onClick={onSelectStudentStepCancelButtonClick}
								>
									<ReturnBackIcon width={18} height={18} />
									{t(
										"internship_selectStudent_actionButton_requestInterviewCancel"
									)}
								</GalkButton>
								<GalkButton
									type="primary"
									width={180}
									onClick={onStudentFinalSelect}
								>
									Confirm
									<RightOutlined />
								</GalkButton>
							</div>
						)}
					</div>
				)}
			{readyToStartInterview && (
				<div className="taggedStudents_stepActionContainer">
					{currentStep === 0 && !studentSelectionEnabled && (
						<div className="justifyContent_end">
							<GalkButton
								type="primary"
								width={180}
								onClick={onDetermineStudentStepButtonClick}
								// disabled={studentsFinallySelected.length === 0}
							>
								{t(
									"internship_determineStudent_actionButton_determineStudents"
								)}
								<RightOutlined />
							</GalkButton>
						</div>
					)}
					{currentStep === 0 && studentSelectionEnabled && (
						<div className="justifyContent_spaceBetween">
							<GalkButton
								width={90}
								type="default"
								onClick={onSelectStudentStepCancelButtonClick}
							>
								<ReturnBackIcon width={18} height={18} />
								{t(
									"internship_selectStudent_actionButton_requestInterviewCancel"
								)}
							</GalkButton>
							<GalkButton
								type="primary"
								width={180}
								onClick={onStudentFinalSelect}
							>
								{t("internship_determineStudent_actionButton_confirmStudents")}
								<RightOutlined />
							</GalkButton>
						</div>
					)}
				</div>
			)}

			{currentStep === 1 && (
				<Divider>{t("determineStudent_finalStep_dividerText")}</Divider>
			)}
			<Row
				style={{
					justifyContent: "space-evenly",
					display: "flex",
					overflowY: "scroll",
					height: "-webkit-fill-available",
				}}
			>
				{currentStep === 0 && studentList.length < 1 && (
					<Col
						span={24}
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}
					>
						<Empty />
					</Col>
				)}
				{currentStep === 0 &&
					studentsInInterviewPanel.map((student, i) => (
						<Col key={i}>
							<StudentCard
								student={student}
								onClick={showStudentDetailsHandler}
							>
								{studentSelectionEnabled && (
									<Checkbox onChange={(e) => onStudentSelect(e, student.id)} />
								)}
							</StudentCard>
						</Col>
					))}
				{currentStep > 0 &&
					studentsFinallySelected.map((student, i) => (
						<Col key={i}>
							<StudentCard
								student={student}
								onClick={showStudentDetailsHandler}
							></StudentCard>
						</Col>
					))}
			</Row>

			<Modal
				title={
					<div style={{ textAlign: "center" }}>
						{`${t("internship_determineStudent_finalStep_confirmModal_title")}`}
					</div>
				}
				centered
				visible={openFinalSelectionConfirmModal}
				onOk={confirmFinalSelection}
				onCancel={() => setOpenFinalSelectionConfirmModal(false)}
				closeIcon={false}
				width={850}
				footer={null}
			>
				<Row justify="center" gutter={20}>
					{studentsFinallySelected.map((student, i) => (
						<Col key={i} gutter={10}>
							<StudentCard
								student={student}
								// onClick={showStudentDetailsHandler}
							></StudentCard>
						</Col>
					))}
				</Row>
				<Divider />
				<Row justify="center" gutter={20}>
					<GalkButton
						type="primary"
						width={190}
						onClick={confirmFinalSelection}
					>
						{t(
							"internship_determineStudent_finalStep_confirmModal_actionButton_determine"
						)}
					</GalkButton>
				</Row>
			</Modal>
			{showStudentDetails && (
				<StudentDetailsDialog
					onCloseHandler={closeStudentDetailsHandler}
					studentDetails={studentDetails}
					isLoading={isLoading}
				/>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	ifActionInProgress: state.company.actionInProgress,
	studentDetails: state.thirdYearStudents.studentToShowDetails,
	isLoading: state.thirdYearStudents.studentToShowDetailsLoading,
	currentInterviewBatch: state.company.company.interviewBatchForInternship,
	studentsSelectedForInterview:
		state.company.company.galkRecruitStudentsSelectedForInterview || [],
	studentsfinallySelectedForInternship:
		state.company.company.galkRecruitStudentsSelectedForInternship || [],
});

export default connect(mapStateToProps, {
	getStudentDetails,
	resetStudentToShowDetails,
	selectStudentsAfterInterview,
})(withRouter(InterviewPanel));
